import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import Backdrop from '../Backdrop';

const Modal = React.forwardRef(function Modal(
  {
    children,
    BackdropComponent = Backdrop,
    BackdropProps,
    hideBackdrop = false,
    disableBackdropClick = false,
    onBackdropClick,
    onClose,
    isOpen,
    ...props
  },
  ref
) {
  const handleBackdropClick = event => {
    if (event.target !== event.currentTarget) {
      return;
    }

    if (onBackdropClick) {
      onBackdropClick(event);
    }

    if (!disableBackdropClick && onClose) {
      onClose(event, 'backdropClick');
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Root ref={ref} {...props}>
      {!hideBackdrop && (
        <BackdropComponent isOpen={isOpen} onClick={handleBackdropClick} {...BackdropProps} />
      )}
      {children}
    </Root>
  );
});

Modal.displayName = 'Modal';

Modal.propTypes = {
  children: PropTypes.node,
  BackdropComponent: PropTypes.elementType,
  BackdropProps: PropTypes.shape({}),
  hideBackdrop: PropTypes.bool,
  disableBackdropClick: PropTypes.bool,
  onBackdropClick: PropTypes.func,
  onClose: PropTypes.func,
  isOpen: PropTypes.bool.isRequired
};

const Root = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  z-index: 100;
`;

export default Modal;
